// extracted by css-extract-rspack-plugin
export default {"DialogFooterButtons":"CheckTagNameDialog-module__DialogFooterButtons__jbi95"};